<template>
<div>
  <div v-if="isMobile === true">
    <mobile-navbar></mobile-navbar>
  </div>
  <div v-else>
    <div :style="style" class="navbar-align-wrapper navbar-color fix-top" :class="colorya ? 'bgColor' : ''">
      <div class="navbar">
        <div class="logo"><img src="@/assets/img/logo.jpg"/></div>
        <div class="navbar-div">
          <ul>
            <li @click="jumpTo(tab, index)" :class="currentTab === index ? 'textColor' : ''" v-for="(tab, index) in navTabs" :key="index">{{tab.title}}</li>
            <li>|</li>
            <li @click="openOrder">预约咨询</li>
            <li class="textColor" v-on:mouseover="down">
              下载APP
              <img v-if="isShowPic" class="erweima" src="@/assets/img/erweima.png" alt="">
            </li>
          </ul>
        </div>
      </div>
    </div>
    <Order ref="order" />
  </div>
</div>
</template>

<script>
import MobileNavbar from './mobile/MobileNavbar.vue'
import { getTopList } from '../api/api.js'
import { ElMessage } from 'element-plus'
import Order from './Order.vue'

export default {
  components: { Order, MobileNavbar },
  data () {
    return {
      isMobile: false,
      colorya: true,
      currentTab: 0,
      navTabs: [
        { path: '/', title: '首页' },
        { path: '/about', title: '关于新界' },
        { path: '/search', title: '房源搜索' },
        { path: '/hui', title: '新界活动' },
        { path: '/customer', title: '企业客户' },
        { path: '/contact', title: '联系新界' }
      ],
      style: {},
      isShowPic: false
    }
  },
  watch: {
    '$route' (to, from) {
      // console.log('to', to)
      if (to.path === '/about' || (to.path.indexOf('/searchDetail') != -1 )) {
        this.colorya = true
        this.style = {}
      } else {
        this.colorya = false
      }
    },
    colorya (newVal, oldVal) {
      if (!this.colorya) {
        window.addEventListener('scroll', this.watchscroll)
      } else {
        window.removeEventListener('scroll', this.watchscroll)
      }
    }
  },
  mounted () {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    if (flag) { // 手机端
      this.isMobile = true
    }
  
    !this.colorya && window.addEventListener('scroll', this.watchscroll)
    console.log('this.$route', this.$route)
    this.getTopList()
  },
  unmounted () {
    !this.colorya && window.removeEventListener('scroll', this.watchscroll)
  },
  methods: {
    down () {
      this.isShowPic = !this.isShowPic
    },
    openOrder () {
      this.$refs.order.open()
    },
    async getTopList () {
      try {
        const res = await getTopList()
        this.navTabs = res.data
        localStorage.setItem('navbars', JSON.stringify(this.navTabs))
      } catch (err) {
        ElMessage.error(err.message)
      }
    },
    watchscroll () {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 100) {
        this.style = {
          background: '#3b585b'
        }
      } else {
        this.style = {
          background: 'rgba(255, 255, 255, 0)'
        }
      }
    },
    jumpTo (tab, index) {
      this.currentTab = index
      this.$router.push(tab.path)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar-align-wrapper {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100px;
  line-height: 100px;
  z-index: 666;
  .navbar {
    min-width: 1200px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 100px 0 100px;
    width: 100%;
    .logo {
      img {
        width: 150px;
        height: 49px;
        display: inline-block;
        position: relative;
        top: -13px;
      }
    }
    .navbar-div {
      ul {
        // display: flex;
        // flex-direction: row;
        // justify-content: space-between;
        // align-items: center;
        li {
          margin-right: 35px;
          float: left;
          // margin-left: 65px;
          font-size: 18px;
          cursor: pointer;
          transition: 1s;
          position: relative;
          &:hover {
            color: #e5006e;
          }
          &:last-child {
            text-decoration: underline;
          }
          span {
            display: inline-block;
          }
          .erweima {
            width: 120px;
            height: 120px;
            position: absolute;
            top: 75px;
            left: -24px;
          }
        }
      }
    }
  }
}
.navbar-color {
  color: #fff;
  // background: rgba(255, 255, 255, 0.5);
}
.fix-top {
  position: fixed;
  top: 0;
}
</style>
